import { IoLocationOutline } from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { Box, Typography, Divider, useTheme, useMediaQuery } from "@mui/material";
import UserImage from "../components/UserImage";
import FlexBetween from "../components/FlexBetween";
import WidgetWrapper from "../components/WidgetWrapper";
import { tokens } from "../theme";

const UserWidget = ({ isCompact = false, ...props }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  return (
    <WidgetWrapper>
      {/* ENCABEZADO */}
      <FlexBetween gap="1rem" pb="1rem">
        <UserImage
          image="https://picsum.photos/200/300"
          size={isSmallScreen ? "50px" : isCompact ? "60px" : "80px"}
          codigoOperador={props.codigoOperador}
        />
        <Box textAlign="left">
          <Typography
            variant="h5"
            color={colors.greenAccent[500]}
            fontWeight="500"
            sx={{
              "&:hover": { color: colors.greenAccent[400], cursor: "pointer" },
            }}
          >
            {props.codigoOperador}
          </Typography>
          <Typography color={colors.black[950]} fontSize={isSmallScreen ? "0.9rem" : "1rem"}>
            {props.nombreOperador}
          </Typography>
        </Box>
      </FlexBetween>

      {/* Si NO es compacto, mostrar detalles adicionales */}
      {!isCompact && (
        <>
          <Divider sx={{ mb: 2 }} />

          {/* DATOS DE CONTACTO */}
          <Box display="grid" gap={2}>
            <Box display="flex" alignItems="center" gap="1rem">
              <MdOutlineMarkEmailUnread size={24} color={colors.gov[500]} />
              <Typography color={colors.black[950]} fontSize="0.95rem">
                {props.email}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap="1rem">
              <BsTelephone size={20} color={colors.gov[500]} />
              <Typography color={colors.black[950]} fontSize="0.95rem">
                {props.telefono}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap="1rem">
              <IoLocationOutline size={26} color={colors.gov[500]} />
              <Typography color={colors.black[950]} fontSize="0.95rem">
                {props.direccion}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ mt: 2, mb: 2 }} />

          {/* DATOS ADICIONALES */}
          <Box display="grid" gap={2}>
            <FlexBetween>
              <Typography color={colors.gov[500]} fontSize="0.95rem" fontWeight="600">
                RTN
              </Typography>
              <Typography color={colors.black[950]} fontSize="0.95rem">
                {props.rtn}
              </Typography>
            </FlexBetween>

            <FlexBetween>
              <Typography color={colors.gov[500]} fontSize="0.95rem" fontWeight="600">
                Denominación
              </Typography>
              <Typography color={colors.black[950]} fontSize="0.95rem">
                {props.denominacion}
              </Typography>
            </FlexBetween>
          </Box>

          <Divider />
        </>
      )}
    </WidgetWrapper>
  );
};

export default UserWidget;
